/**
 * Use this for any calendar datetime string shown in SSR + hydrated React (contractor
 * dashboard, billing, etc.). Rails must send a matching `*Display` field built with
 * `SsrDateDisplay` in the business timezone. Avoid `toLocaleDateString` / `toLocaleString`
 * for those same values—Node SSR and the browser can disagree (React error #418).
 *
 * Admin tables may use `formatAdminTableDate` with `locale` + `timeZone` from server props.
 */
export function ssrFormattedDateOr(
  serverDisplay: string | null | undefined,
  ifBlank = "—",
): string {
  if (serverDisplay == null || serverDisplay === "") {
    return ifBlank;
  }
  return serverDisplay;
}
